import './header.scss';

import { bool } from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { Collapse, Nav, Navbar, NavbarBrand, NavItem } from 'reactstrap';

import NotificationsPopup from '../../comments/NotificationsPopup';
import SessionTimer from '../../signin/SessionTimer';
import { ENV } from '../../utils/env';
import Logo from '../Logo';
import * as Variant from '../Variant';
import { isSuperuser } from '../Variant/Variant';
import AccountingNavigation from './AccountingNavigation';
import AdOpsNavigation from './AdOpsNavigation';
import CollabaryNavigation from './CollabaryNavigation';
import LeadNavigation from './LeadNavigation';
import PCNavigation from './PCNavigation';
import SalesBackOfficeNavigation from './SalesBackOfficeNavigation';
import UserIconPopoverDetails from './UserIconPopoverDetails';

function Header({ showNavigation }) {
  return (
    <Navbar
      fixed="top"
      expand="md"
      dark
      className={`bg-black c-environment-${ENV}`}
    >
      <NavbarBrand tag={Link} to="/">
        <Logo />
      </NavbarBrand>

      {ENV !== 'production' && (
        <span className="c-environment-hint">{ENV}</span>
      )}
      {showNavigation && (
        <Collapse navbar>
          <Nav className="ml-auto" navbar>
            <Variant.PC>
              <PCNavigation />
            </Variant.PC>
            <Variant.AdOps>
              <AdOpsNavigation />
            </Variant.AdOps>
            <Variant.Accounting>
              <AccountingNavigation />
            </Variant.Accounting>
            <Variant.Lead>
              <LeadNavigation />
            </Variant.Lead>
            <Variant.SalesBackoffice>
              <SalesBackOfficeNavigation />
            </Variant.SalesBackoffice>
            <Variant.Collabary>
              <CollabaryNavigation />
            </Variant.Collabary>
            <NavItem>
              <SessionTimer />
            </NavItem>
            <NavItem>
              <NotificationsPopup />
            </NavItem>
            <NavItem>
              <a
                className="nav-link"
                href="https://sites.google.com/zalando.de/salescockpit/home"
                target="_blank"
                rel="noreferrer"
              >
                Wiki
              </a>
            </NavItem>
            {isSuperuser() && (
              <NavItem>
                <a className="nav-link" href="/salesforce-contract">
                  Salesforce Contract Generator
                </a>
              </NavItem>
            )}
            <NavItem>
              <UserIconPopoverDetails />
            </NavItem>
          </Nav>
        </Collapse>
      )}
    </Navbar>
  );
}

Header.propTypes = {
  showNavigation: bool,
};

Header.defaultProps = {
  showNavigation: true,
};

export default Header;
